import React from "react";
import useTranslate from "hooks/use-translate-language";
import selectors from "selectors";
import { useSelector } from "react-redux";
import "./schedule-chat.scss";
import DatePicker from "./DatePicker";

const ChooseDate = ({ date, setSelectedDate }) => {
  const translate = useTranslate();
  const { CompanyAllowsWeekends } = useSelector(selectors.getUserDetails);

  return (
    <div>
      <div style={{ marginLeft: "2%", marginTop: "1%" }}>
        <h2 className="topic-title">{translate("selectADate")}</h2>
      </div>
      <div
        style={{
          display: "flex"
        }}      
        role="grid"
        tabIndex={0}
        aria-label="Date Picker"
      >
        <DatePicker
          date={date}
          setDate={setSelectedDate}
          isFetching={false}
          companyAllowsWeekends={CompanyAllowsWeekends}
          actions={["today"]}
        />
      </div>
    </div>
  );
};

export default ChooseDate;
